import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { useIntl } from 'react-intl';

import { FontAwesomeIcon } from 'atoms/icons';
import { playerDetails } from 'lib/glossary';

type Props = { starting: boolean; width?: number };
export const PlayingStatusIcon = ({ starting, width }: Props) => {
  const { formatMessage } = useIntl();

  if (starting) {
    return (
      <FontAwesomeIcon
        icon={faCircleCheck}
        color="var(--c-score-high)"
        title={formatMessage(playerDetails.starting)}
        width={width}
      />
    );
  }

  return (
    <FontAwesomeIcon
      icon={faCircleXmark}
      color="var(--c-red-400)"
      title={formatMessage(playerDetails.notStarting)}
      width={width}
    />
  );
};
